import { apiEndPoints, apiHeaders, apiMethods } from '../../../utils/apiConstants'
import myPeeguAxios from '../../../utils/myPeeguAxios'

const silentHeaders = {
	headers: {
		[apiHeaders.preventDefaultLoader]: true,
		[apiHeaders.preventDefaultToast]: true,
	},
}

const noToastHeaders = {
	headers: {
		[apiHeaders.preventDefaultToast]: true,
	},
}

export async function fetchMyPermissions() {
	const response = await myPeeguAxios[apiMethods.get](
		apiEndPoints.permissionMe,
		silentHeaders,
	)
	return response.data.message
}

export async function fetchPermissionMatrix() {
	const response = await myPeeguAxios[apiMethods.get](
		apiEndPoints.permissionMatrix,
		silentHeaders,
	)
	return response.data.message
}

export async function updateRolePermissions(roleOpsId, payload) {
	const response = await myPeeguAxios[apiMethods.put](
		`${apiEndPoints.permissionRole}/${roleOpsId}`,
		payload,
		noToastHeaders,
	)
	return response.data.message
}

export async function createRole(payload) {
	const response = await myPeeguAxios[apiMethods.post](
		apiEndPoints.permissionRole,
		payload,
		noToastHeaders,
	)
	return response.data.message
}

export async function deleteRole(roleOpsId) {
	const response = await myPeeguAxios[apiMethods.delete](
		`${apiEndPoints.permissionRole}/${roleOpsId}`,
		noToastHeaders,
	)
	return response.data.message
}

export async function fetchRoleSummary(roleName) {
	const response = await myPeeguAxios[apiMethods.get](
		`${apiEndPoints.permissionRoleSummary}/${encodeURIComponent(roleName)}/summary`,
		silentHeaders,
	)
	return response.data.message
}

export async function fetchRoleUsers(roleName) {
	const response = await myPeeguAxios[apiMethods.get](
		`${apiEndPoints.permissionRoleSummary}/${encodeURIComponent(roleName)}/users`,
		silentHeaders,
	)
	return response.data.message
}
